import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-texture" />
      <div className="hero-inner">
        <div>
          <div className="hero-kicker">For Irish &amp; UK Business Owners</div>
          <h1 className="display">
            You run your business.<br />
            <span className="line-rest">We handle the rest.</span>
          </h1>
          <p className="hero-sub">
            The emails, the follow-ups, the stock checks, the reports, the admin —
            <strong> all the things eating your day</strong> that aren't actually your job.
            We set up smart systems to handle them. You focus on what you're good at.
          </p>
          <div className="hero-actions">
            <a href="#cta" className="btn btn-solid">Book a Free 30-Minute Call &rarr;</a>
            <a href="#problems" className="btn btn-ghost">See What We Fix &darr;</a>
          </div>
          <div className="hero-reassure">
            <span className="reassure-item">Free discovery call</span>
            <span className="reassure-item">No technical knowledge needed</span>
            <span className="reassure-item">Results within 30 days</span>
            <span className="reassure-item">Any business, any sector</span>
          </div>
        </div>
        <div className="hero-right">
          <div className="float-card fc-1">
            <div className="fc-label green">Sales follow-up — automated</div>
            <div className="fc-row"><span className="fc-key">Quotes sent this week</span><span className="fc-val">12</span></div>
            <div className="fc-row"><span className="fc-key">Auto follow-ups sent</span><span className="fc-val g">12</span></div>
            <div className="fc-row"><span className="fc-key">Manually chased by you</span><span className="fc-val g">0</span></div>
            <div className="fc-row"><span className="fc-key">Converted so far</span><span className="fc-val g">5</span></div>
            <div className="fc-badge green">Running while you sleep</div>
          </div>
          <div className="float-card fc-2">
            <div className="fc-label amber">Your time — this week</div>
            <div className="fc-row"><span className="fc-key">Email handling</span><span className="fc-val r">Before: 7hrs</span></div>
            <div className="fc-row"><span className="fc-key">Email handling</span><span className="fc-val g">After: 1.5hrs</span></div>
            <div className="fc-row"><span className="fc-key">Admin &amp; data entry</span><span className="fc-val g">Automated</span></div>
            <div className="fc-row"><span className="fc-key">Time freed up</span><span className="fc-val g">+11hrs</span></div>
            <div className="fc-badge amber">11 hours back every week</div>
          </div>
          <div className="float-card fc-3">
            <div className="fc-label blue">This month at a glance</div>
            <div className="fc-row"><span className="fc-key">Revenue vs target</span><span className="fc-val g">108%</span></div>
            <div className="fc-row"><span className="fc-key">Best performing service</span><span className="fc-val">Plan B</span></div>
            <div className="fc-row"><span className="fc-key">Overdue invoices</span><span className="fc-val r">3 — chasing</span></div>
            <div className="fc-row"><span className="fc-key">New leads this week</span><span className="fc-val g">8</span></div>
            <div className="fc-badge blue">Live dashboard. Always up to date.</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
